/* eslint-disable @typescript-eslint/naming-convention */
export class TransferBaseResponseDto {
	public Data?: string[];
	public LoggingStyles?: string[];
	public Errors?: string[];
	public ErrorCode?: number;
	public ErrorMessage?: string;
}
